import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareViewNotFoundClassicRoute: InvariantJiraRoute = {
	name: 'software-view-not-found-classic',
	exact: true,
	path: '/jira/software/c/projects/:projectKey/not-found',
};
